import { render } from "./TaskList.vue?vue&type=template&id=a5ed039c&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=a5ed039c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5ed039c"

export default script